import { render } from "./App.vue?vue&type=template&id=e7b52e8a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e7b52e8a&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__